import React, { useEffect, useState } from 'react';
import CommonCheckbox from '../../../components/CommonCheckBox/CommonCheckbox';
import DateAndTimePickers from '../../../components/DateTimePicker/DateTimePicker';
import moment from 'moment';
import DashboardDateFilter from '../../../../components/DashboardDateFilter/DashboardDateFilter';
const DateFilter = ({
  masterFilter,
  updateFilters,
  doReset,
  updateSelectionFieldsInHTMLFormatForDeSelect
}) => {
  let fromDate = masterFilter?.dateFilter?.startDate;
  let lDate = masterFilter?.dateFilter?.endDate;

  const [date, setDate] = useState('today');
  const [startDate, setStartDate] = useState(
    fromDate ? moment(fromDate).toDate() : moment().toDate()
  );

  const [toDate, setToDate] = useState(
    lDate ? moment(lDate).toDate() : moment().toDate()
  );

  const subtractDays = days =>
    moment()
      .subtract('day', days)
      .toDate();

  const subtractMonths = month =>
    moment()
      .subtract('month', month)
      .toDate();

  const handleDate = day => {
    if (day == 'today') {
      setStartDate(subtractDays('0'));
      setToDate(subtractDays('0'));
    } else if (day == 'yesterday') {
      setStartDate(subtractDays('1'));
      setToDate(subtractDays('1'));
    } else if (day == 'week') {
      setStartDate(subtractDays('7'));
      setToDate(subtractDays('0'));
    } else if (day == 'month') {
      setStartDate(subtractMonths('1'));
      setToDate(subtractMonths('0'));
    } else if (day == '6Month') {
      setStartDate(subtractMonths('6'));
      setToDate(subtractMonths('0'));
    }
    setDate(day);
  };
  useEffect(() => {
    if (doReset) {
      setStartDate(moment().toDate());
      setToDate(moment().toDate());
    }
  }, [doReset]);

  const checkDateDiff = (startDay, endDay) =>
    moment(startDate).isSame(moment().subtract('day', startDay), 'day') &&
    moment(toDate).isSame(moment().subtract('day', endDay), 'day');

  const checkMonthDiff = (startMonth, endMonth) =>
    moment(startDate).isSame(moment().subtract('month', startMonth), 'day') &&
    moment(toDate).isSame(moment().subtract('month', endMonth), 'day');

  const checkDateRanges = () => {
    if (checkDateDiff('0', '0')) setDate('today');
    else if (checkDateDiff('1', '1')) setDate('yesterday');
    else if (checkDateDiff('7', '0')) setDate('week');
    else if (checkMonthDiff('1', '0')) setDate('month');
    else if (checkMonthDiff('6', '0')) setDate('6Month');
    else {
      setDate('custom');
    }
  };

  useEffect(() => {
    checkDateRanges();
    updateFilters({
      key: 'dateFilter',
      filters: {
        startDate: startDate,
        endDate: toDate
      }
    });

    updateSelectionFieldsInHTMLFormatForDeSelect({
      key: 'dateFilersSelections',
      object: {
        startDate: {
          name: `From Date - ${moment(startDate).format('YYYY-MMM-DD')}`,
          value: startDate
        },
        endDate: {
          name: `To Date - ${moment(toDate).format('YYYY-MMM-DD')}`,
          value: toDate
        }
      },
      handleCancel: handleCancel,
      displayName: 'name'
    });
  }, [startDate, toDate]);

  const handleCancel = e => {
    setStartDate(e?.startDate?.value || moment().toDate());
    setToDate(e?.endDate?.value || moment().toDate());
  };
  const inputStyle = {
    marginTop: '0px',
    backgroundColor: 'transparent'
  };
  return (
    <div className="w-full">
      <p className="font-roboto font-medium text-base">Date Filter</p>

      <div className="w-11/12  mt-3 md:absolute relative hidden md:flex">
        <DashboardDateFilter
          getValuesByProps={true}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={toDate}
          setEndDate={setToDate}
        />
      </div>
      <div className="border border-orange-600 rounded table items-center px-2 flex md:hidden">
        <div className="table items-center grid grid-cols-2 bg-transparent py-2">
          <div className="">
            <input
              type="date"
              style={inputStyle}
              value={moment(startDate)?.format('YYYY-MM-DD')}
              onChange={e => setStartDate(e?.target?.value)}
              className="text-black-500 w-full"
            />
          </div>
          <div className="">
            <input
              type="date"
              style={inputStyle}
              value={moment(toDate)?.format('YYYY-MM-DD')}
              onChange={e => setToDate(e?.target?.value)}
              className="text-black-500 w-full"
            />
          </div>
        </div>
      </div>

      <div className="w-full mt-6 grid grid-cols-2  md:grid-cols-3 gap-4 relative mt-4 md:mt-20">
        <div className="flex ">
          <CommonCheckbox
            checked={date == 'today' ? true : false}
            onChange={() => handleDate('today')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">Today</p>
        </div>
        <div className="flex  ">
          <CommonCheckbox
            checked={date == 'yesterday' ? true : false}
            onChange={() => handleDate('yesterday')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">Yesterday</p>
        </div>
        <div className="flex  ">
          <CommonCheckbox
            checked={date == 'week' ? true : false}
            onChange={() => handleDate('week')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">1 Week</p>
        </div>

        <div className="flex  ">
          <CommonCheckbox
            checked={date == 'month' ? true : false}
            onChange={() => handleDate('month')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">1 Month</p>
        </div>

        <div className="flex  ">
          <CommonCheckbox
            checked={date == '6Month' ? true : false}
            onChange={() => handleDate('6Month')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">6 Month</p>
        </div>

        <div className="flex ">
          <CommonCheckbox
            checked={date == 'custom' ? true : false}
            onChange={() => handleDate('custom')}
          />
          <p className="text-grey-2234 font-roboto text-sm -ml-2">Custom</p>
        </div>
      </div>
    </div>
  );
};
export default DateFilter;
